var React = require('react');

function LiquorIcon (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#303c42;stroke-linecap:round;stroke-linejoin:round}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("ellipse",{"className":"cls-1","cx":"11","cy":"3","rx":"10.5","ry":"2.5","key":0}),React.createElement("path",{"className":"cls-1","d":"M.74 3.56L11 15.5M21.26 3.56L11 15.5m-1 10c-3.13.14-5.54 1-5.54 2s2.91 2 6.5 2 6.5-.9 6.5-2-2.41-1.84-5.54-2","key":1}),React.createElement("path",{"className":"cls-1","d":"M11 15.5s0 11.38 2 11.38c0 .35-.9.62-2 .62s-2-.28-2-.62c2 0 2-11.38 2-11.38z","key":2})]))]);
}

LiquorIcon.displayName = "LiquorIcon";

LiquorIcon.defaultProps = {"viewBox":"0 0 22 30"};

module.exports = LiquorIcon;

LiquorIcon.default = LiquorIcon;
